import { Reveal } from "@components/ui";

const solutions = [
  {
    title: "Residential Customers",
    bullets: [
      "Safe kitchen gas supply",
      "Clear monthly bills",
      "Smart meters",
      "24/7 support",
      "Easy online bill payments",
    ],
  },
  {
    title: "Commercial & F&B",
    bullets: [
      "Reliable supply for restaurants & hotels",
      "Quarterly safety audits",
      "Solenoid valve integration",
      "Commercial safety compliance",
      "Priority emergency response",
    ],
  },
  {
    title: "Developers & Owner Associations",
    bullets: [
      "Full design, installation & commissioning",
      "Sub-metering & billing solutions",
      "Dedicated relationship manager",
      "Technical audits & DCD compliance",
    ],
  },
];

export function CustomerSolutionsSection() {
  return (
    <section className="w-full bg-[#f1f1f1] pt-[40px] md:pt-[50px] lg:pt-[60px] pb-12 md:pb-16 lg:pb-[120px] px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto">
        {/* Header */}
        <Reveal>
          <div className="flex flex-col items-center text-center mb-10 md:mb-12 lg:mb-14">
            <h2 className="text-[28px] md:text-[44px] lg:text-[54px] font-semibold text-[#090d2c] tracking-[-0.04em] leading-[1.1] font-albert-sans">
              Solutions for Every Customer
            </h2>
            <p className="mt-3 text-[18px] md:text-[22px] lg:text-[28px] text-[rgba(10,14,46,0.75)] tracking-[-0.04em] font-albert-sans">
              We have solutions provided for every customer
            </p>
          </div>
        </Reveal>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {solutions.map((solution) => (
            <Reveal key={solution.title}>
              <div className="group bg-white rounded-[24px] overflow-hidden p-6 hover:shadow-[0_8px_24px_rgba(0,0,0,0.08)] transition-all duration-300 hover:-translate-y-1 h-full">
                <h3 className="text-[22px] md:text-[28px] font-semibold text-[#1c1c1c] tracking-[-0.04em] font-albert-sans mb-5">
                  {solution.title}
                </h3>
                <ul className="flex flex-col gap-3">
                  {solution.bullets.map((bullet) => (
                    <li
                      key={bullet}
                      className="flex items-center gap-2"
                    >
                      <span className="w-2 h-2 rounded-full bg-[#62636c] shrink-0" />
                      <span className="text-[16px] md:text-[18px] text-[rgba(10,14,46,0.75)] tracking-[-0.04em] leading-[26px] font-albert-sans">
                        {bullet}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
